module.exports = __webpack_public_path__ + "static/media/note.fa0c6a40.svg";